import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { TSIContractorImagePayloadFields } from '@components/delaerVisit/components/contractorDetailForm';
import { ErrorHandler } from '@helper/errorHandler';

interface ITSIUploadImageData {
	mutate: UseMutateFunction<TSIContractorImagePayloadFields, Error, TSIContractorImagePayloadFields, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useTSIUploadImage = (): ITSIUploadImageData => {
	const uploadImageDetails = async (
		dealerDetails: TSIContractorImagePayloadFields
	): Promise<TSIContractorImagePayloadFields> => {
		try {
			return await APIService.postData<TSIContractorImagePayloadFields>(`${APICONFIG.TSI_IMAGE_UPLOAD}`, dealerDetails);
		} catch (error) {
			ErrorHandler(error);
			return {};
		}
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: uploadImageDetails,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
